// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Jp01","link":"_3y--N","selectContainer":"_2Izv7","select":"_3ECkD"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/categories-link/categories-link.scss
// module id = 1419
// module chunks = 0